import { Routes } from '@angular/router';
import { authGuard, stageGuard } from "../../_shared/helpers";
import { PersonsComponent } from "./persons/persons.component";
import { PersonDetailsComponent } from "./person-details/person-details.component";
import { PersonUpdateComponent } from "./person-update/person-update.component";
import { PersonAddComponent } from "./person-add/person-add.component";

export const PERSON_ROUTES: Routes = [
  {
    path: 'persons',
    pathMatch: 'full',
    redirectTo: 'persons/overview'

  },
  {
    path: 'persons/overview',
    component: PersonsComponent,
    canActivate: [authGuard]
  },
  {
    path: 'person/details/:pid',
    component: PersonDetailsComponent,
    canActivate: [authGuard]
  },
  {
    // Diese beiden schreiben NICHT ins CRM -- person-add/-update fuehren die
    // crm_id nur mit. Der stageGuard steht hier allein deshalb, weil die
    // zugehoerigen Schaltflaechen auf DEV ausgeblendet sind und Oberflaeche
    // und Routen sonst auseinanderlaufen. Wer Personen auf DEV testen will,
    // nimmt ihn hier wieder heraus -- bei den Kontaktrouten nicht.
    path: 'person/update/:pid',
    component: PersonUpdateComponent,
    canActivate: [authGuard, stageGuard]
  },
  {
    // dito
    path: 'person/add/:cid',
    component: PersonAddComponent,
    canActivate: [authGuard, stageGuard]
  }
];
